const rawBase = process.env.REACT_APP_API_BASE || '';

export const API_BASE = rawBase.replace(/\/$/, '');

export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${p}`;
}

/** 固件公开下载完整 URL（4G 模组 HTTP GET，无需登录） */
export function firmwareDownloadUrl(downloadPath) {
  const p = downloadPath.startsWith('/') ? downloadPath : `/${downloadPath}`;
  if (API_BASE) {
    return `${API_BASE}${p}`;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${p}`;
  }
  return p;
}

/** 新标签页打开受保护 API 时使用（如 id.html），附带短随机 actk */
export function apiUrlWithAccessToken(path) {
  const url = apiUrl(path);
  const actk = localStorage.getItem('actk');
  if (!actk) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}actk=${encodeURIComponent(actk)}`;
}
